import React from "react";

// Status is never shown by colour alone: every badge carries a text label (and a dot).
// Tones map to the brand status colours: danger / warning / info / safe / neutral.
export const SEVERITY_TONE = { threat: "danger", warning: "warning", info: "info", none: "neutral" };
export const TIER_TONE = { confirmed: "danger", auto_confirmed: "danger", suspected: "warning", heuristic: "warning", cleared: "safe", none: "neutral" };
export const LLM_TONE = { malicious: "danger", suspicious: "warning", benign: "safe", unsure: "neutral" };
export const PUBLIC_STATUS_TONE = { malicious: "danger", suspicious: "warning", clean_seen: "safe", unknown: "neutral" };

export default function StatusBadge({ tone = "neutral", children, testid, title }) {
  return <span className={`hs-badge hs-badge-${tone}`} data-testid={testid} title={title}>{children}</span>;
}
